import { render, staticRenderFns } from "./WebMain.vue?vue&type=template&id=2a173475&scoped=true"
import script from "./WebMain.vue?vue&type=script&lang=js"
export * from "./WebMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a173475",
  null
  
)

export default component.exports